import { Observable } from "micro-observables";
import { Signal } from "micro-signals";
import { Page, PaginationOptions } from "@utils/page";
import { PaginatedData } from "@core/paginatedData";
import { PaginatedStore, SimplePaginatedStore } from "./paginatedStore";
import { Store } from "./store";
import { idToItem } from "./utils";

export class StorePresentation<T extends { id: string }, Args extends unknown[] = []> implements PaginatedStore<
	T,
	unknown,
	Args
> {
	private readonly _paginatedStore: PaginatedStore<T, unknown, Args>;

	onFetch: Signal<{ args: Args; result: Page<unknown> }>;

	get fetching(): Observable<boolean> {
		return this._paginatedStore.fetching;
	}

	constructor(
		private readonly _store: Store<T>,
		fetchList: (page: PaginationOptions, ...args: Args) => Promise<Page<T>>
	) {
		this._paginatedStore = new SimplePaginatedStore<T, unknown, Args>(fetchList);
		this._paginatedStore.paginatedItems.onChange((data) => {
			if (data === null) {
				return;
			}
			this._store.merge(data.content);
		});
		this.onFetch = this._paginatedStore.onFetch;
	}

	get paginatedItems(): Observable<PaginatedData<T> | null> {
		return Observable.from(this._store.itemsById, this._paginatedStore.paginatedItems).transform(
			([items, paginatedItems]) => idToItem(items, paginatedItems)
		);
	}

	fetch(...args: Args): Promise<void> {
		return this._paginatedStore.fetch(...args);
	}
	fetchMore(...args: Args): Promise<void> {
		return this._paginatedStore.fetchMore(...args);
	}
}
